module.exports = __webpack_public_path__ + "img/share.d44fc568.svg";